/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// const { localStorage } = window;

export const storage = {
  read(key) {
    let fromStorage = null;

    try {
      fromStorage = localStorage.getItem(key)
        && JSON.parse(localStorage.getItem(key));
    } catch (err) {
      console.log(err); // eslint-disable-line
    }

    return fromStorage;
  },

  write(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (err) {
      console.log(err); // eslint-disable-line
    }

    return data;
  },

  destroy(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.log(err); // eslint-disable-line
    }
  },
};
